import styled from "@emotion/styled";

export const SideBarContainer = styled.nav`
  width: 70px;
  min-width: 70px;
  flex: 0 0 60px; /* importante: no permitir que el flex lo comprima */
  max-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 40px 8px;
  background-color: #0b3e5f;

  height: 100vh;
  box-sizing: border-box;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  transition: width 200ms ease, padding 200ms ease;

  &.expanded {
    width: 280px;
    flex: 0 0 280px; /* cuando expande, reservar el ancho */
    padding: 24px;
    align-items: flex-start;
  }

  .disabled {
    opacity: 0.5;
    cursor: default;

    &:hover {
      background-color: transparent !important;

      svg {
        transform: none !important;
      }
    }
  }

  @media (max-width: 720px) {
    &.expanded {
      position: fixed;
      left: 0;
      top: 60px;
      height: calc(100vh - 60px);
      z-index: 1500;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    }
  }
`;

export const IconContainer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 55px;
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  font: inherit;

  &:hover:not([aria-disabled="true"]) {
    background-color: #0d3547;
    border-radius: 10px;
    svg {
      transform: scale(1.15);
    }
  }

  svg {
    transition: transform 300ms ease;
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
    border-radius: 10px;
  }

  /* Estilos para item seleccionado */
  &.selected {
    background-color: #437084;
    border-radius: 10px;
  }

  &.selected svg circle,
  &.selected svg .dot {
    fill: #437084;
  }

  &.selected:hover {
    background-color: #0d3547;
  }

  &.selected:hover svg circle,
  &.selected:hover svg .dot {
    fill: #0d3547;
  }

  &.disabled,
  &[aria-disabled="true"] {
    opacity: 0.5;
    cursor: default;

    &:hover {
      background-color: transparent !important;

      svg {
        transform: none !important;
      }
    }
  }
`;
